/**
 * Registers the service worker for the application.
 *
 * Attempts to register a service worker at '/service-worker.js' with root scope
 * when the window loads. Will log success or failure to the console.
 * Only runs if the browser supports service workers.
 *
 * @returns void
 */
export const registerServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/service-worker.js', { scope: '/' })
        .then(registration => {
          console.log('SW registered: ', registration)
        })
        .catch(registrationError => {
          console.log('SW registration failed: ', registrationError)
        })
    })
  }
}
